/* global bocAmchart */

/**
 * Default title styles
 */
bocAmchart.titleStyles = {
    'default': {
        'size': {
            'charttitle': 14,
            'subtitle': 12
        },
        'bold': {
            'subtitle': false
        }
    },
    'big': {
        'size': {
            'charttitle': 18,
            'subtitle': 12
        },
        'bold': {
            'subtitle': false
        }
    },
    'bos': {
        'size': {
            'charttitle': 16,
            'subtitle': 12
        },
        'bold': {
            'subtitle': false
        }
    },
    'small': {
        'size': {
            'charttitle': 13,
            'subtitle': 12
        }
    }
};

/**
 * Sets the titles based on provided shortcode parameters
 * @param {AMConfig} chart chart config json
 * @returns {void}
 */
bocAmchart.setTitlesFromShortcode = function (chart) {
//Sets default title style unless otherwise set
    if (!chart.bocSettings.args.hasOwnProperty("titlestyle")) {
        chart.bocSettings.args.titlestyle = 'default';
    }

    if (Object.keys(chart.titles).length === 0) {
        var titles = ['charttitle', 'subtitle'];
        titles.forEach(function (title) {
            if (chart.bocSettings.args.hasOwnProperty(title)) {
                if (bocAmchart.debug(chart)) {
                    // eslint-disable-next-line no-console
                    console.log(
                        chart.bocSettings.id,
                        "Adding " + title + " from shortcode",
                        ":",
                        chart.bocSettings.args[title]
                    );
                }
                bocAmchart.addChartTitle(chart, title, chart.bocSettings.args[title]);
            }
        });
    }
};

/**
 * Adds specific title to the chart
 * @param {AMConfig} chart chart config json
 * @param {string} titleType charttitle/subtitle
 * @param {string} text actual text for the title
 * @returns {void}
 */
bocAmchart.addChartTitle = function (chart, titleType, text) {
    var thisTitleStyle = chart.bocSettings.args.titlestyle;
    var properties = {};
    var property;

    if (bocAmchart.titleStyles.hasOwnProperty(thisTitleStyle)) {
        properties = bocAmchart.titleStyles[thisTitleStyle];
    }

    if (typeof chart.bocSettings.titleStyles === 'object') {
        if (chart.bocSettings.titleStyles.hasOwnProperty(thisTitleStyle)) {
            for (property in chart.bocSettings.titleStyles[thisTitleStyle]) {
                if (chart.bocSettings.titleStyles[thisTitleStyle].hasOwnProperty(property)) {
                    properties[property] = chart.bocSettings.titleStyles[thisTitleStyle][property];
                }
            }
        }
    }

    // Remove the shortcodes for now
    // Will re-evaluate the subtitle once the data is loaded
    var shortcodes = /{{series(\d+)\.(date|value)}}/g;
    text = text.replace(shortcodes, '');

    var titlesItem = {
        'text': text
    };

    for (property in properties) {
        if (properties.hasOwnProperty(property) && properties[property].hasOwnProperty(titleType)) {
            titlesItem[property] = properties[property][titleType];
        }
    }

    chart.titles.push(titlesItem);
};

/**
 * Processes subtitle to replace all the placeholders with actual last modified date and last value
 *
 * @param {object} chart AMChart object
 * @param {object} data Object containing the valet data sets after postProcessor
 * @returns {void} Processed string
 */
bocAmchart.processSubtitle = function (chart, data) {

    if (!chart.bocSettings.args.hasOwnProperty('subtitle')) {
        return;
    }

    var subtitle = chart.bocSettings.args.subtitle;

    var dateReg = /{{series(\d+)\.date}}/g;
    var series = [];
    var dateVar;
    var dates = [];
    // eslint-disable-next-line no-cond-assign
    while (dateVar = dateReg.exec(subtitle)) {
        dates.push(dateVar);
        if (series.indexOf(dateVar[1]) === -1) {
            series.push(dateVar[1]);
        }
    }

    var valueReg = /{{series(\d+)\.value}}/g;
    var valueVar;
    var values = [];
    // eslint-disable-next-line no-cond-assign
    while (valueVar = valueReg.exec(subtitle)) {
        values.push(valueVar);
        if (series.indexOf(valueVar[1]) === -1) {
            series.push(valueVar[1]);
        }
    }

    // If there's no shortcodes used - return without any changes
    if (series === []) {
        return;
    }

    var seriesNames = [];
    var fieldsCount = 0;
    series.forEach(function (index) {
        if (typeof chart.graphs[index] !== 'undefined' && chart.graphs[index].hasOwnProperty('valueField')) {
            seriesNames.push({
                'index': index,
                'name': chart.graphs[index].valueField
            });
            fieldsCount++;
        }
    });

    for (var i = data.length; i > 0 && fieldsCount > 0; i--) {
        seriesNames.forEach(function (seriesName) {
            if (seriesName.hasOwnProperty("value")) {
                return;
            }
            // Grab the last data point
            var dataPoint = data[i - 1];

            if (dataPoint.hasOwnProperty(seriesName.name)) {
                seriesName.value = dataPoint[seriesName.name];
                seriesName.date = dataPoint['date'];
                fieldsCount--;
            }
        });
    }

    seriesNames.forEach(function (seriesName) {
        dates.forEach(function (date) {
            if (date[1] === seriesName.index) {
                subtitle = subtitle.replace(date[0], seriesName.date);
            }
        });
    });

    seriesNames.forEach(function (seriesName) {
        values.forEach(function (value) {
            if (value[1] === seriesName.index) {
                subtitle = subtitle.replace(value[0], seriesName.value);
            }
        });
    });

    if (chart.titles.length === 2) {
        chart.titles[1].text = subtitle;
    } else {
        // In case the subtitle is used without chartTitle
        chart.titles[0].text = subtitle;
    }
};
